<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-list"></i>
                                <span>Activitate/Flux de lucru</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="d-flex justify-content-end m-2">
                        <button type="button" style="background-color:#3c8dbc; border-color: #367fa9; color: #fff"
                            class="button-doc" (click)="openAddNewDestinationDialog()">
                            <i class="fa-solid fa-plus add-icon"></i>
                            <span> Adaugă Destinatari</span>
                        </button>
                    </div>
                    <mat-divider></mat-divider>
                    <table class="table table-condensed table-wrapper-box">
                        <thead>
                            <tr>
                                <th>Crt.</th>
                                <th>Sursa</th>
                                <th>Destinație</th>
                                <th>Status</th>
                                <th>Info</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="!activityData.length">
                                <td colspan="5" class="text-center">
                                    <strong><i>Lipsă înregistrări</i></strong>
                                </td>
                            </tr>
                            <ng-container *ngIf="activityData.length">
                                <tr *ngFor="let row of activityData; let i = index;">
                                    <td width="2%">{{ i + 1 }}</td>
                                    <td width="30%">
                                        <div><i class="fa fa-book custom-spacing-icon"></i> {{ row.origin_directie_name || "N/A" }}</div>
                                        <div><i class="fa fa-cubes custom-spacing-icon"></i> {{ row.origin_compartiment_name || "N/A" }}</div>
                                        <div><i class="fa fa-user custom-spacing-icon"></i> {{ row.origin_user_name || "N/A" }}</div>
                                    </td>
                                    <td width="30%">
                                        <div><i class="fa fa-book custom-spacing-icon"></i> {{ row.destination_directie_name || "N/A"}}</div>
                                        <div><i class="fa fa-cubes custom-spacing-icon"></i> {{ row.destination_compartiment_name ||"N/A" }}</div>
                                        <div><i class="fa fa-user custom-spacing-icon"></i> {{ row.destination_user_name || "N/A" }}</div>
                                        <div *ngIf="row.registratura_number !== null">
                                            <strong>Registru: </strong> {{row.registratura_serie}} <br>
                                            <strong><i class="fa fa-tag custom-spacing-icon"></i> {{row.registratura_number}} / {{row.registratura_date}}</strong>
                                        </div>

                                        <div *ngIf="row.registratura_number !== null"
                                            class="flex-display-buttons">

                                            <!-- here we add the possibility to add documents extra -->
                                            <!-- Rules -->
                                            <!-- To not be canceled -->
                                            <!-- To not be closed/validated -->
                                            <!-- For registratura official, to have the permission to add docs intrare -->
                                            <!-- For other registers, is permitted -->
                                            <!-- To not be iesire, because we can not do a intern -->
                                            <!-- To not be closed -->
                                            <button type="button"
                                                class="btn btn-sm btn-success m5"
                                                (click)="openAddDialogIntrare(row.registratura_serie_id || 0, row.registratura_number, row.id)"
                                                *ngIf="docData.cancel_date == null 
                                                && docData.validated_date == null 
                                                && (
                                                    (checkPermissionFromView('indoc-module.registratura_documents.operations.add-intrare-completare') 
                                                    && registruOficialValue === (row.registratura_serie_id + '')) 
                                                    ||
                                                    (registruOficialValue !== (row.registratura_serie_id + ''))
                                                )
                                                && docData.id_categorie == 1 && docData.current_status !== 4
                                                && row.registratura_number !== null
                                                && compareNumbers(row.destination_directie_id, activeAccess.id_directie)
                                                && compareNumbers(row.destination_compartiment_id, activeAccess.id_compartiment)">
                                                <i class="fa fa-sign-in"></i> Completare
                                            </button>
                                            <!-- Rules -->
                                            <!-- To not be canceled -->
                                            <!-- To not be closed/validated -->
                                            <!-- For other registers, is permitted -->
                                            <!-- To not be iesire, because we can not do a intern -->
                                            <!-- To not be closed -->
                                            <button type="button"
                                                class="btn btn-sm btn-info m5"
                                                (click)="openAddDialogIntern(row.registratura_serie_id || 0, row.registratura_number, row.id)"
                                                *ngIf="docData.cancel_date == null 
                                                && docData.validated_date == null 
                                                && checkPermissionFromView('indoc-module.registratura_documents.operations.add-intern') 
                                                && registruOficialValue !== (row.registratura_serie_id + '') 
                                                && docData.id_categorie !== 2 && docData.current_status !== 4
                                                && row.registratura_number !== null
                                                && compareNumbers(row.destination_directie_id, activeAccess.id_directie)
                                                && compareNumbers(row.destination_compartiment_id, activeAccess.id_compartiment)">
                                                <i class="fa fa-map-signs"></i> Intern
                                            </button>
                                            <!-- Rules -->
                                            <!-- To not be canceled -->
                                            <!-- To not be closed/validated -->
                                            <!-- For other registers, is permitted -->
                                            <!-- To not be iesire, because we can not do a intern -->
                                            <!-- To not be closed -->        
                                            <button type="button"
                                                class="btn btn-sm btn-warning m5"
                                                (click)="openAddDialogIesire(1, row.registratura_serie_id || 0, row.registratura_number, row.id)"
                                                *ngIf="docData.cancel_date == null 
                                                && docData.validated_date == null 
                                                && checkPermissionFromView('indoc-module.registratura_documents.operations.add-iesire') 
                                                && docData.id_categorie !== 2 && docData.current_status !== 4
                                                && row.registratura_number !== null
                                                && compareNumbers(row.destination_directie_id, activeAccess.id_directie)
                                                && compareNumbers(row.destination_compartiment_id, activeAccess.id_compartiment)">
                                                <i class="fa fa-sign-out"></i> Iesire
                                            </button>                                                    
                                        </div>

                                        <hr *ngIf="row.children_documents.length > 0"/>

                                        <p *ngIf="row.children_documents.length > 0"><strong><u>Documente initiate/relationate</u></strong></p>

                                        <span class='secondary-document-numbers m5' 
                                            style="cursor: pointer !important" 
                                            *ngFor="let docChildren of row.children_documents" 
                                            (click)="openInNewTab(docChildren.id_document)">
                                            <span [innerHTML]="docChildren.registru"></span> 
                                        </span>

                                        <hr *ngIf="row.registratura_number !== null" />

                                        <button type="button" *ngIf="checkPermissionFromView('indoc-module.registratura_documents.document-view.preluare_document_in_lucru')
                                                && docData.cancel_date == null
                                                && docData.validated_date == null
                                                && row.active == 1
                                                && row.activity_from_date == null
                                                && compareNumbers(row.destination_directie_id, activeAccess.id_directie)
                                                && compareNumbers(row.destination_compartiment_id, activeAccess.id_compartiment)
                                                " (click)="preluareDocumentInLucru(row.id)"
                                                    class="btn btn-sm m5 btn-success btn-block">Preluare
                                                    Document</button>

                                        <button type="button" class="btn btn-sm btn-block btn-success"
                                                style="margin-top: 10px;" 
                                                *ngIf="checkPermissionFromView('indoc-module.registratura_documents.document-view.finalizare_document_in_lucru')
                                                && docData.cancel_date == null
                                                && docData.validated_date == null
                                                && row.active == 1
                                                && row.activity_from_date !== null
                                                && row.activity_end_date == null
                                                && compareNumbers(row.destination_directie_id, activeAccess.id_directie)
                                                && compareNumbers(row.destination_compartiment_id, activeAccess.id_compartiment)
                                                " (click)="finalizareDocumentInLucru(row.id)">Finalizare
                                                    document</button>

                                        <button type="button" class="btn btn-sm btn-block btn-primary"
                                            style="margin-top: 10px;" *ngIf="docData.cancel_date == null
                                                && docData.validated_date == null
                                                && row.active == 1
                                                && row.activity_from_date !== null
                                                && row.activity_end_date == null
                                                && compareNumbers(row.destination_directie_id, activeAccess.id_directie)
                                                && compareNumbers(row.destination_compartiment_id, activeAccess.id_compartiment)
                                                && row.registratura_number == null && row.allowed_registratura == true
                                                " (click)="preluareNumarRegistru(row.id)">Preluare Nr
                                                    Registru</button>

                                        <!-- revert preluare numar -->
                                        <button type="button" class="btn btn-sm btn-block btn-danger"
                                                *ngIf="docData.cancel_date == null 
                                                && docData.validated_date == null
                                                && row.activity_end_date !== null
                                                && (row.validated_date !== null || row.cancel_date !== null)
                                                && (
                                                    (   
                                                        row.destination_user_id == currentUser.id_user
                                                        && checkPermissionFromView('indoc-module.registratura_documents.document-view.rollback-status-preluat-document') 
                                                    )
                                                    ||
                                                    checkPermissionFromView('indoc-module.registratura_documents.operations-admin.rollback-status-preluat-document')
                                                )"
                                                (click)="rollBackDocumentInLucru(row.id)">
                                                Revenire stadiu anterior</button>

                                                <!-- && docData.id_user !== row.origin_user_id
                                                && docData.id_directie !== row.origin_directie_id -->
                                        <button type="button" class="btn btn-sm btn-block btn-warning"
                                                    *ngIf="docData.cancel_date == null
                                                && docData.validated_date == null
                                                && row.active == 1
                                                && row.activity_end_date == null
                                                && row.registratura_number == null
                                                && row.activity_from_date !== null
                                                && row.validated_date == null
                                                && row.cancel_date == null
                                                && row.destination_user_id == currentUser.id_user
                                                && compareNumbers(row.destination_directie_id, activeAccess.id_directie)
                                                && compareNumbers(row.destination_compartiment_id, activeAccess.id_compartiment)" 
                                                style="margin-top: 10px;"
                                                    (click)="rollPreluareDocumentInLucru(row.id)">Anulare
                                                    preluare document</button>
                                        
                                    </td>
                                    <td width="19%">
                                        <p>{{row.status}}</p>


                                        <!-- Remove from activity formalities -->
                                        <!-- Rules -->
                                        <!-- It is not taken by any operators -->
                                        <button type="button" class="btn btn-sm btn-danger btn-block"
                                            *ngIf="row.active === 1 && row.activity_from_date === null
                                            && checkPermissionFromView('indoc-module.registratura_documents.operations-admin.remove-flux-document')"
                                            (click)="removeDocumentActivity(row.id)">
                                            Șterge Destinație</button>



                                    </td>
                                    <td width="19%">
                                        <span><strong>Creat: </strong> {{ row.created_at ? (row.created_at | europeanDate : "dd.MM.yyyy HH:mm") : "N/A" }}</span><br />
                                        <span><strong>Borderou: </strong> {{ row.borderou_date_sent ? (row.borderou_date_sent | europeanDate : "dd.MM.yyyy HH:mm") : "N/A" }}</span><br />
                                        <span><strong>Preluat: </strong> {{ row.activity_from_date ? (row.activity_from_date | europeanDate : "dd.MM.yyyy HH:mm") : "N/A" }}</span><br />
                                        <span *ngIf="row.validated_date == null && row.cancel_date == null">
                                            <strong>Trimis: </strong> {{ row.activity_end_date ? (row.activity_end_date | europeanDate : "dd.MM.yyyy HH:mm") : "N/A" }}<br />
                                        </span>
                                        <span *ngIf="row.validated_date !== null">
                                            <span>Rezolutie: {{row.validated_summary}}</span><br />
                                            <span>Obs: {{row.validated_obs || 'n/a'}}</span> <br />
                                            <span>Data: {{ row.validated_date ? (row.validated_date | europeanDate : "dd.MM.yyyy HH:mm") : "N/A" }}
                                            </span>
                                        </span>
                                        <span *ngIf="row.cancel_date !== null">
                                            <span>Obs: {{row.cancel_obs || 'n/a'}}</span> <br />
                                            <span>Dată Anulare: {{ row.cancel_date ? (row.cancel_date | europeanDate : "dd.MM.yyyy HH:mm") : "N/A" }}</span>
                                        </span>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-folder-tree"></i>
                                <span>Documente relaționate</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <!-- <div class="d-flex justify-content-end m-2">
                        <button type="button" style="background-color:#f39c12; border-color: #e08e0b; color: #fff"
                            class="button-doc" (click)="openAddDialogIesire()">
                            <i class="fa-solid fa-plus add-icon"></i>
                            <span> Adaugă Document Ieșire</span>
                        </button>
                    </div>
                    <mat-divider></mat-divider> -->
                    <table class="table table-condensed table-wrapper-box">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Tip Document</th>
                                <th>Tip Acces</th>
                                <th>Cale de intrare</th>
                                <th>Status</th>
                                <th>Prioritate</th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="childrenData.length == 0">
                                <td colspan="7" class="text-center">
                                    <strong><i>Lipsă înregistrări</i></strong>
                                </td>
                            </tr>

                            <ng-container *ngIf="childrenData.length > 0">
                                <tr *ngFor="let child of childrenData; let i = index;">
                                    <td>
                                        <strong>{{child.reg_number}}</strong> /
                                        <strong>{{child.reg_date}}</strong><br />
                                        <strong>{{child.source}}</strong> <br/>
                                        <button class="btn btn-sm btn-info" (click)="openInNewTab(child.id_document)">
                                            <i class="fa fa-external-link"></i> Deschide
                                        </button>
                                    </td>
                                    <td>{{child.subject}}</td>
                                    <td>{{child.categorie}}</td>
                                    <td>
                                        <span *ngFor="let source of child.sourceArr; let last = last">
                                            {{ source }}<span *ngIf="!last">, </span>
                                        </span>
                                        <span *ngIf="child.sourceArr.length == 0"><i>Lipsa inregistrari</i></span>
                                    </td>
                                    <td><span [innerHTML]="child.status | safeHtml"></span></td>
                                    <td>
                                        <span [innerHTML]="child.priority | safeHtml"></span><br />
                                        <span [innerHTML]="child.sla | safeHtml"></span>
                                    </td>
                                    <td>
                                        <span><strong>Creat: </strong>{{child.created || 'n/a'}}</span><br />
                                        <span><strong>Actualizat: </strong>{{child.updated || 'n/a'}}</span><br />
                                        <span class="hidden"><strong>Formular: </strong>{{child.name_print || 'n/a'}}</span>
                                        <span class="orange-text pointer hidden" 
                                            *ngIf="!child.toggle_update_print && checkPermissionFromView('dgaspc_registratura_document_editare_tip_formular')"
                                            (click)="updateFormular(child.id_document)">
                                            <i class="fa fa-pencil"></i>
                                        </span>
                                        <span class="red-text pointer hidden" 
                                            *ngIf="child.toggle_update_print"
                                            (click)="child.toggle_update_print = false">
                                            <i class="fa fa-times"></i>
                                        </span>
                                        <!-- <div *ngIf="child.toggle_update_print" class="d-flex align-items-center">
                                            <select name="id_print" id="id_print" 
                                                    [(ngModel)]="child.id_print"
                                                    class="form-control mr-2" 
                                                    style="max-width: 80%;">
                                                <option *ngFor="let print of printBlades" [value]="print.id">
                                                    {{print.name}}
                                                </option>
                                            </select>
                                            <button type="button" class="btn btn-sm btn-success"
                                                    (click)="updatePrintBladeId(child.id_document, child.id_print)">
                                                <i class="fa fa-check"></i> Modifică
                                            </button>
                                        </div> -->
                                        <!-- <br />
                                        <button type="button" class="btn btn-sm btn-block btn-primary hidden"
                                                [disabled]="child.id_print == null"
                                                (click)="printBladeDocument(child.id_document)">
                                            <i class="fa fa-download"></i> Descarcă
                                        </button> -->
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-envelope"></i>
                                <span>INBOX</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <table class="table table-condensed table-wrapper-box">
                        <thead>
                            <tr>
                                <th>Crt.</th>
                                <th>Subiect</th>
                                <th>Expeditor</th>
                                <th>Data primit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="!docData.emails.length">
                                <td colspan="4" class="text-center">
                                    <strong><i>Lipsă înregistrări</i></strong>
                                </td>
                            </tr>
                            <ng-container *ngIf="docData.emails.length">
                                <tr *ngFor="let row of docData.emails; let i = index;" class="email-row"
                                    (click)="openEmail(row)">
                                    <td>
                                        {{ i + 1 }}
                                    </td>
                                    <td>
                                        {{ row.subject }}
                                    </td>
                                    <td>
                                        {{ row.from_email }}
                                    </td>
                                    <td>
                                        {{ row.received_date_time | europeanDate : "dd.MM.yyyy HH:mm" }}
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>